<template>
  <a-modal
    :visible="visible"
    okText="开始检测"
    :width="600"
    @ok="handleCreate"
    cancellText="取消"
    @cancel="visible = false"
    title="创建检测任务">
    <a-alert :style="{ marginBottom: '15px' }" message="如果检测范围为通讯录好友，请您先到会员管理，通讯录刷新好友"></a-alert>
    <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-form-item label="选择检测范围" >
        <a-select
          v-decorator="['fans_round', {initialValue:1,rules: [{required: true, message: '必填项'}]}]"
        >
          <a-select-option :value="2">会员好友</a-select-option>
          <a-select-option :value="1">通讯录好友</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="检测时间间隔"
        :wrapperCol="wrapperCol">
        <a-input-number
          :min="0"
          :formatter="value => `${value}秒`"
          v-decorator="['min_time', {initialValue:120,rules: [{required: true, message: '必填项'}]}]">
        </a-input-number>
        -
        <a-input-number
          :min="0"
          :formatter="value => `${value}秒`"
          v-decorator="['max_time', {initialValue:30,rules: [{required: true, message: '必填项'}]}]">
        </a-input-number>
      </a-form-item>
      <a-form-item label="自动改备注">
        <a-switch v-decorator="['remark_switch', {initialValue: false, valuePropName: 'checked'}]"></a-switch>
      </a-form-item>
      <a-form-item label="备注" v-if="form.getFieldValue('remark_switch')">
        <a-input v-decorator="['remark', {initialValue: '[昵称]'}]"></a-input>
        <a-tag v-for="(item, index) in badge" @click="copyText(item)" :key="index">{{ item }}</a-tag>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CreateInactiveModal',
  data () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      currentRobotId: 0,
      labelCol: {
        span: 8
      },
      wrapperCol: {
        span: 12
      },
      badge: [
        '[昵称]',
        '[最后下单时间]',
        '[会员组]',
        '[总订单数]',
        '[待结算奖励]',
        '[推荐人数]',
        '[有效推荐人数]',
        '[可提现金额]',
        '[历史提现金额]',
        '[用户UID]',
        '[注册时间]',
        '[自定备注]'
      ]
    }
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
    show (currentRobotId) {
      this.visible = true
      this.currentRobotId = currentRobotId
    },
    copyText (text) {
      this.$copyText(text)
      this.$message.success('复制成功')
    },
    handleCreate () {
      this.form.validateFields((err, values) => {
        this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
          robotid: this.currentRobotId,
          type: 'die_fans',
          data: values
        }).then(result => {
          this.$message.success('发送指令成功')
          this.visible = false
        })
      })
    }
  }
}
</script>
